import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";

angular
  .module('bringoz.admin.action-reasons')
  .factory('$actionReasons', ActionReasonsObjectFactory);

/* @ngInject */
function ActionReasonsObjectFactory($bringozFactory: $bringozFactory,
                                    ActionReasonsAPI: BringozApi,
                                    ActionReasons_DS: DataStoreConfig) {

  function $actionReasons(id: string) {
    return $bringozFactory(id, ActionReasonsAPI, ActionReasons_DS)
  }

  return $actionReasons;
}
